import React, { memo } from 'react';
import { List } from '@material-ui/core';

import ListItem from './ListItem';

const ProfessionalList = ({ list, onSelect }) => (
  <List>
    {list.map(({ id, name, areaName }) => (
      <ListItem
        key={id}
        id={id}
        name={name}
        area={areaName}
        onClick={() => onSelect(id)}
      />
    ))}
  </List>
);
export default memo(ProfessionalList);
